import _ from 'lodash'
import {capitalCase as title} from "capital-case";

function storeHasTags(selectedStoreTags) {
  return storeOption => _.some(_.intersectionBy(storeOption.tags, selectedStoreTags, 'value'))
}

function getStoresWithAnyBusinessUnit(storeOptions, businessUnit) {
  let filteredStoreOptions = _.filter(storeOptions, storeHasTags([{'value': businessUnit}]))
  return _.map(filteredStoreOptions, s => s.value)
}

function getStoresWithAnyTags(storeOptions, storeTagOptions) {
  const selectedStoreTags = storeTagOptions.map(s => {
    return {value: s.value}
  })
  let filteredStoreOptions = _.filter(storeOptions, storeHasTags(selectedStoreTags))
  return _.map(filteredStoreOptions, s => s.value)
}

function getStoreTagOptionsByStoreOptions(storesOptions) {
  let uniqueStoreTags = _.orderBy(_.uniq(_.flatMap(storesOptions, o => o.tags)))
  let storeTagOptions = _.map(uniqueStoreTags, (tag) => ({label: title(tag.value), value: tag.value, type: tag.type}))
  let storeTagOptionsWithGroupName = _.map(_.groupBy(storeTagOptions, 'type'), (g, i) => {
    let group = _.uniqBy(g, 'value')
    if (i === 'businessUnit') {
      return {
        label: i, options: _.map(group, (a) => {
          return {label: a.value, value: a.value}
        })
      }
    }
    return {
      label: i, options: _.map(group, (a) => {
        return {label: _.capitalize(a.value), value: a.value}
      })
    }
  })
  return storeTagOptionsWithGroupName;
}

function getDefaultStoreSelectValues(storeOptions) {
  return _.map(getDefaultStoreSelectOptions(storeOptions), s => s.value)
}

function getDefaultStoreSelectOptions(storeOptions) {
  return _.filter(storeOptions, o => !_.some(_.get(o, 'tags', []),
    t => t && t.type === 'manualSelect' && t.value === 'true'))
}

export default {
  getStoresWithAnyTags,
  getStoresWithAnyBusinessUnit,
  storeHasTags,
  getStoreTagOptionsByStoreOptions,
  getDefaultStoreSelectValues,
  getDefaultStoreSelectOptions
}



// WEBPACK FOOTER //
// ./src/services/store-tags-service.js